import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setStage } from './store/stage/actions';

import StageSelect from 'bundles/apex/stage_select';

export function PlaybookStages({ dealTypeOptions, playbook, setStage, stage, stages }) {
  const dealTypeLabel = dealTypeOptions.find(option => option.value ===  playbook.dealType).label;

  let prefix = 'a';
  if (playbook.dealType === 'other') {
    prefix = 'an';
  }

  let suffix = '';
  if (playbook.dealType === 'buyer_rep' || playbook.dealType === 'tenant_rep' || playbook.dealType === 'other') {
    suffix = 'deal';
  }

  const select = <StageSelect setStage={setStage} stage={stage} stages={stages} />;

  return (
    <div className="my-5">
      <div className="stage-transition-label">
        When {prefix} <b>{dealTypeLabel}</b> {suffix} transitions to {select}
      </div>
    </div>
  );
}


PlaybookStages.propTypes = {
  dealTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  playbook: PropTypes.shape({
    dealType: PropTypes.string.isRequired,
  }).isRequired,
  setStage: PropTypes.func.isRequired,
  stage: PropTypes.object,
  stages: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  dealTypeOptions: state.dealTypeOptions,
  stage: state.stage,
  stages: state.stages,
});

const mapDispatchToProps = {
  setStage,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaybookStages);
